import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";

import { WizardButtons } from "shared/components/WizardNew/components/WizardButtons";
import { WizardData } from "shared/components/WizardNew/types";

import { simplyClick } from "shared/helpers/analytics";

import { useWizard, WizardStep } from "shared/hooks/useWizard";

import { postWizardFinish } from "shared/services/wizard";

import styles from "@platformAssets/components/Wizard.module.scss";

import welcomeAnimation from "@sharedAssets/lotties/welcome_abroad.json";

type Props = { wizardData: WizardData };

const WelcomeOneMoreThing = ({ wizardData }: Props) => {
  const navigate = useNavigate();

  const { t } = useTranslation("wizardNew");

  const wizard = useWizard(wizardData);

  const step = wizard[WizardStep.OneMoreThing];

  const handleClick = async () => {
    await postWizardFinish();

    step.analytics?.start?.forEach((item: string) => {
      simplyClick(item, null, false);
    });

    navigate(`/${step?.nextStep}`);
  };

  const handlePrevious = () => {
    navigate(`/${step?.previousStep}`);
  };

  return (
    <div className={styles.welcomeContainer}>
      <WizardButtons
        variant="welcome"
        showBack={true}
        onBack={handlePrevious}
        userData={wizardData}
      />

      <div className={styles.welcome}>
        <div className={styles.wizardAnimationWrapper}>
          <Lottie
            animationData={welcomeAnimation}
            loop={true}
            autoplay={true}
            className={styles.wizardFinishAnimationWrapper}
            rendererSettings={{
              preserveAspectRatio: "xMidYMid slice",
            }}
          />
        </div>

        <div className={styles.wizardInfoWrapper}>
          <div className={styles.welcomeTextWrapper}>
            <div>
              <div className={styles.welcomeTitle}>
                {t("oneMoreThing.title")}
              </div>
              <div className={styles.welcomeDescription}>
                {t("oneMoreThing.description")}
              </div>
            </div>
          </div>

          <div className={styles.btnWrap}>
            <button onClick={handleClick} className={styles.welcomeButton}>
              {t("oneMoreThing.btn")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export { WelcomeOneMoreThing };
